<template>
  <div>
    <list
      ref="list"
      unit="采购订单"
      row-key="Id"
      :page="page"
      :query-params="params"
      :show-checkbox="true"
      :show-query="showQuery"
      @reset-query="$emit('reset-select')"
      :reRowClick="true"
      :get-row-click-func="myRowClick"
      :get-data-func="getDataFunc"
      :summaryMethod="summaryFunc"
      :show-summary="summaryShow"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="供应商名称">
          <supplier @restaurants="setSupplier" :state="params.SupplierName" />
        </el-form-item>
        <el-form-item label="单据编号">
          <el-input clearable v-model="params.DocNo" placeholder="请输入单据编号" />
        </el-form-item>
        <el-form-item label="单据状态">
          <el-select v-model="params.Status" placeholder="请选择" clearable>
            <el-option label="草稿" :value="0"></el-option>
            <el-option label="未生效" :value="1"></el-option>
            <el-option label="已生效" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单据日期">
          <el-date-picker
            v-model.trim="params.DocDateStart"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
          <span style="margin:0 10px;">-</span>
          <el-date-picker
            v-model.trim="params.DocDateEnd"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="入库状态">
          <el-select v-model="params.InStatus" placeholder="请选择" clearable>
            <el-option label="未入库" :value="0"></el-option>
            <el-option label="部分入库" :value="1"></el-option>
            <el-option label="已入库" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="完成状态">
          <el-select v-model="params.CompleteStatus" placeholder="请选择" clearable>
            <el-option label="未完成" :value="0"></el-option>
            <el-option label="已完成" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="预计到货日期" label-width="100px">
          <el-date-picker
            v-model.trim="params.DeliveryDateStart"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
          <span style="margin:0 10px;">-</span>
          <el-date-picker
            v-model.trim="params.DeliveryDateEnd"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="DocNo" label="单据编号" />
        <el-table-column prop="DocDate" label="单据日期" min-width="110px">
          <template slot-scope="{row}">{{row.DocDate.split(" ")[0]}}</template>
        </el-table-column>
        <el-table-column prop="SupplierName" label="供应商名称" min-width="90px">
          <template slot-scope="{row}">{{row.SupplierName}}</template>
        </el-table-column>
        <el-table-column prop="Amount" label="订单金额">
          <template slot-scope="{row}">{{$commonJs.toThousands(row.Amount)}}</template>
        </el-table-column>
        <el-table-column prop="ClerkName" label="业务员">
          <template slot-scope="{row}">{{row.ClerkName}}</template>
        </el-table-column>
        <el-table-column prop="Status" label="单据状态">
          <template slot-scope="{row}">
            <span v-if="row.Status==0">草稿</span>
            <span v-else-if="row.Status==1">未生效</span>
            <span v-else>已生效</span>
          </template>
        </el-table-column>
        <el-table-column prop="InStatus" label="入库状态">
          <template slot-scope="{row}">
            <span v-if="row.InStatus==0">未入库</span>
            <span v-else-if="row.InStatus==1">部分入库</span>
            <span v-else>已入库</span>
          </template>
        </el-table-column>
        <el-table-column prop="PayStatus" label="付款状态">
          <template slot-scope="{row}">
            <span v-if="row.PayStatus==0">未付款</span>
            <span v-else-if="row.PayStatus==1">部分付款</span>
            <span v-else>已付款</span>
          </template>
        </el-table-column>
        <el-table-column prop="WxName" label="完成状态">
          <template slot-scope="{row}">
            <span v-if="row.CompleteStatus==0">未完成</span>
            <span v-else>已完成</span>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import supplier from "@/components/common/supplier/supplier";
export default {
  mixins: [listMixin],
  components: { list, supplier },
  beforeMount() {
    this.cApi.list({ pageSize: 100, pageIndex: 1 }).then((res) => {
      this.cList = res.Data;
      sessionStorage.setItem("cList", JSON.stringify(res.Data));
    });
  },
  mounted() {
    this.dpapi.list({}).then((res) => {
      let list = [];
      res.Data.forEach((e) => {
        list.push({ value: e.SupplierName, Id: e.SupplierId });
      });
      this.supplierList = list;
    });
  },
  data() {
    return {
      api: require("@/api/purchase/order").default,
      cApi: require("@/api/ba/tradeUnit").default,
      dpapi: require("@/api/ba/tradeUnit").default,
      cList: [],
      supplierList: [],
      state: "",
      params: {
        DocNo: "",
        CustomerId: null,
        SupplierName: "",
        SupplierId: "",
        DocDateStart: this.$commonJs.getDayOffset(-30),
        DocDateEnd: this.$commonJs.getDayOffset(0),
        DeliveryDateStart: "",
        DeliveryDateEnd: "",
        Status: null,
        OutStatus: null,
        //----------
        pageIndex: 1
      },
      summaryShow: false,
      total:null
    };
  },
  methods: {
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        this.api.list(params).then(res => {
          let times = Math.ceil(res.Count / params.pageSize);
          //判断是否最后一页
          if (times == params.pageIndex) {
            this.api.listTotal(params).then(res => {
              if (res.Code == 0 && res.Data) {
                this.total = res.Data[0];
                this.summaryShow = true;
              } else {
                this.summaryShow = false;
              }
            })
          } else {
            this.summaryShow = false;
          }
          resolve(res);
        })
      })
    },
    summaryFunc(param) {
      const { columns, data } = param;
      var fields = ['Amount']; //需要合计的字段
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        var field = fields.find(x => x == column.property);
        if (field) {
          console.log(field, index);
          sums[index] = "";
          if (this.total) {
            sums[index] = this.total[field].toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          }
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    setSupplier(data) {
      this.params.SupplierId = data.TradeUnitId;
      this.params.SupplierName = data.TradeUnitName;
    },
    handleSelect(item) {
      this.params.SupplierName = item.value;
      this.params.SupplierId = item.Id;
    },
    querySearchAsync(queryString, cb) {
      var supplierList = this.supplierList;
      var results = queryString
        ? supplierList.filter(this.createStateFilter(queryString))
        : supplierList;
      cb(results);
    },
    createStateFilter(queryString) {
      return (state) => {
        if (state.value) {
          return (
            state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
          );
        }
      };
    },
    myRowClick(row, column, e) {
      this.$emit("loading");
      this.api.info(row.OrderId).then((res) => {
        this.$emit("setDetails", res.Data.Goods, row);
        this.$emit("loading");
      });
    },
    setUnit(e) {
      this.params.SupplierId = e.SupplierId;
      this.params.SupplierName = e.SupplierName;
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>